module.exports = __webpack_public_path__ + "static/media/logo.2d53aa50.png";